import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'

import { getUseManualHoursReportsKey } from '@/hooks'

import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import {
  APIErrorResponse,
  ManualHoursReport,
  PatchManualHoursReport,
} from '@/types'

export const usePatchManualHoursReport = (
  id: number
): UseMutationResult<
  ManualHoursReport,
  APIErrorResponse,
  PatchManualHoursReport
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const hrListKey = getUseManualHoursReportsKey(true)
  const employeeListKey = getUseManualHoursReportsKey(false)

  return useMutation(
    (params) =>
      client
        .patch(`/hours_reporting/manual-hours/${id}/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries(hrListKey),
          queryClient.invalidateQueries(employeeListKey),
        ])
      },
    }
  )
}
